import React, { useState, useEffect } from "react";
import Select from "react-select";
import client from "../../../Common/Client/Client";

const TicketBookingForm = ({
  selectedDate,
  adminSelectSeat,
  packageDetails,
  seatLockData,
  setAdminSelectSeat,
  availableSeat,
}) => {
  const [buttonLock, setButtonLock] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [paymentMode, setPaymentMode] = useState("offline");
  const [selectPackageId, setSelectPackageId] = useState();
  const [selectPackagePrice, setSelectPackagePrice] = useState();
  const [error, setError] = useState({});
  const [userContactDetail, setUserContactDetail] = useState({
    adminName: "",
    mobileNumber: "",
    email: "",
    proof: "",
    proofIdNumber: "",
    upiReceipt: "",
  });

  useEffect(() => {
    console.log("admin seat selected");

    if (adminSelectSeat.length > 0) {
      setUserDetails((prevDetails) => {
        const prevId = prevDetails.map((u) => u.id).join(",");
        const newId = adminSelectSeat.map((s) => s.seatId).join(",");

        console.log(prevId);
        console.log(newId);

        if (prevId === newId) {
          console.log("will not allow one seat");
          return prevDetails;
        }

        return adminSelectSeat.map((each) => {
          const existing = prevDetails.find((u) => u.id === each.seatId);
          return (
            existing ?? {
              id: each.seatId,
              number: each.seatNumber,
              name: "",
              age: "",
              gender: "",
              agegroup: "",
            }
          );
        });
      });
    } else {
      setUserDetails([]);
    }
  }, [adminSelectSeat]);

  useEffect(() => {
    setSelectPackageId(packageDetails[0]?._id);
    setSelectPackagePrice(packageDetails[0]?.price);
  }, [packageDetails]);

  const handlePackageSelection = (e) => {
    const selectedPackageId = e.target.value;
    const { price } = packageDetails.find(
      (each) => each._id === selectedPackageId,
    );
    setSelectPackageId(selectedPackageId);
    setSelectPackagePrice(price);
  };

  const handleUserDetail = (e, seatId) => {
    const { name, value } = e.target;
    // console.log(name, value, seatId);

    setUserDetails((prev) =>
      prev.map((eachUser) =>
        eachUser.id === seatId ? { ...eachUser, [name]: value } : eachUser,
      ),
    );
  };

  const handleUserContactDetail = (e) => {
    const { name, value } = e.target;
    // console.log(name);

    setUserContactDetail((prev) => ({ ...prev, [name]: value }));
  };

  const pnrGenerate = () => {
    const randomPart = Math.floor(100000000 + Math.random() * 900000000);
    const randPad = randomPart.toString().padStart(9, "0");
    return `AT${randPad}`;
  };

  const submitAdminBook = async () => {
    setButtonLock(true);
    setError({});
    // console.log(userDetails, userContactDetail);

    const totalPrice = adminSelectSeat.reduce((acc, curr) => {
      acc += Number(selectPackagePrice);
      return acc;
    }, 0);

    // console.log(totalPrice);

    const userTicketDetails = userDetails.map((each) => ({
      ...each,
      ...userContactDetail,
      price: Number(selectPackagePrice),
      totalPrice: totalPrice,
      PNR: pnrGenerate(),
      bookingStatus: "booked",
    }));

    const completeTicketDetails = {
      userTicketDetails,
      selectedDate,
      selectPackageId,
    };

    // console.log("userTicketDetails", completeTicketDetails);
    try {
      const response = await client.post(
        "/admin-book/book",
        completeTicketDetails,

        {
          withCredentials: true,
        },
      );

      // console.log("adminSubmit", response);
      if (response.status === 200) {
        
        const byteCharacters = atob(response.data);
        const byteNumbers = Array.from(byteCharacters).map((c) =>
          c.charCodeAt(0),
        );
        const byteArray = new Uint8Array(byteNumbers);

        const pdfBlob = new Blob([byteArray], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = "Bus-ticket.pdf";
        link.click();
        seatLockData();
        setUserContactDetail({
          adminName: "",
          mobileNumber: "",
          email: "",
          proof: "",
          proofIdNumber: "",
          upiReceipt: "",
        });
        setUserDetails([]);
        setSelectPackageId(packageDetails[0]?._id);
        setSelectPackagePrice(packageDetails[0]?.price);
        setPaymentMode("offline");
        setAdminSelectSeat([]);
        setButtonLock(false);
      }
    } catch (error) {
      console.log(error);

      console.log("adminTicketError", error.response.data.resultErrorArray);
      if (
        error.status === 400 &&
        error.response.data.message === "serverError"
      ) {
        setError(error.response.data.resultErrorArray);
        return false;
      }

      // if (error.status === 409) {
      //   alert();
      // }

      alert("Internal Server Error");
    }
  };

  // console.log("error", error);
  console.log("userDetails", userDetails);
  console.log("adminSelect", adminSelectSeat);
  // console.log("usercontactdetail", userContactDetail);

  return (
    <>
      {availableSeat.length > 0 && (
        <div className="ticket-wrapper">
          <div className="row my-4">
            <div className="col-md-6">
              <h6>Package</h6>
              <select
                class="form-select"
                aria-label="Default select example"
                name="group"
                onChange={handlePackageSelection}
              >
                {packageDetails &&
                  packageDetails?.map((each) => (
                    <option value={each._id}>{each.packageName}</option>
                  ))}
              </select>
            </div>
            <div className="col-md-6">
              <h6>Admin Name</h6>
              <input
                type="text"
                name="adminName"
                value={userContactDetail?.adminName}
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                onChange={handleUserContactDetail}
              />
              {error && error["userTicketDetails[0].adminName"] && (
                <p style={{ color: "red" }}>
                  {error["userTicketDetails[0].adminName"]}
                </p>
              )}
            </div>
          </div>
          <div className="row">
            <h5>Passenger Details</h5>
            <div className="col-md-6 mt-3 mt-4">
              <h6>Mobile Number</h6>
              <input
                type="text"
                name="mobileNumber"
                value={userContactDetail.mobileNumber}
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                onChange={handleUserContactDetail}
              />
              {error && error["userTicketDetails[0].mobileNumber"] && (
                <p style={{ color: "red" }}>
                  {error["userTicketDetails[0].mobileNumber"]}
                </p>
              )}
            </div>
            <div className="col-md-6 mt-3 mt-4">
              <h6>Email Id</h6>
              <input
                type="text"
                name="email"
                value={userContactDetail.email}
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                onChange={handleUserContactDetail}
              />
              {error && error["userTicketDetails[0].email"] && (
                <p style={{ color: "red" }}>
                  {error["userTicketDetails[0].email"]}
                </p>
              )}
            </div>

            <div className="col-md-6 mt-3 mt-4">
              <h6>Customer Id</h6>
              <input
                type="text"
                name="proof"
                value={userContactDetail.proof}
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                onChange={handleUserContactDetail}
              />
              {error && error["userTicketDetails[0].proof"] && (
                <p style={{ color: "red" }}>
                  {error["userTicketDetails[0].proof"]}
                </p>
              )}
            </div>
            <div className="col-md-6 mt-3 mt-4">
              <h6>Id Number</h6>
              <input
                type="text"
                name="proofIdNumber"
                value={userContactDetail.proofIdNumber}
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                onChange={handleUserContactDetail}
              />
              {error && error["userTicketDetails[0].proofIdNumber"] && (
                <p style={{ color: "red" }}>
                  {error["userTicketDetails[0].proofIdNumber"]}
                </p>
              )}
            </div>
            <div className="col-md-12 mt-4">
              <h6 style={{ marginBottom: "20px" }}>Selected Seat</h6>
              {adminSelectSeat.length > 0 &&
                adminSelectSeat.map((each) => (
                  <span className="selected-seat">{each.seatNumber}</span>
                ))}
            </div>

            <div className="col-md-12 mt-4">
              <h6>User Details</h6>
              {adminSelectSeat.length > 0 &&
                adminSelectSeat.map((each, i) => (
                  <div className="row" key={each.seatId}>
                    <div className="col-md-3 mt-2">
                      <h6>Name</h6>
                      <input
                        type="text"
                        name="name"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        onChange={(e) => handleUserDetail(e, each.seatId)}
                      />
                      {error && error[`userTicketDetails[${i}].name`] && (
                        <p style={{ color: "red" }}>
                          {error[`userTicketDetails[${i}].name`]}
                        </p>
                      )}
                    </div>
                    <div className="col-md-3 mt-3">
                      <h6>age</h6>
                      <input
                        type="email"
                        name="age"
                        class="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        onChange={(e) => handleUserDetail(e, each.seatId)}
                      />
                      {error && error[`userTicketDetails[${i}].age`] && (
                        <p style={{ color: "red" }}>
                          {error[`userTicketDetails[${i}].age`]}
                        </p>
                      )}
                    </div>
                    <div className="col-md-3 mt-3">
                      <h6>Gender</h6>
                      <select
                        class="form-select"
                        value={each.gender}
                        aria-label="Default select example"
                        name="gender"
                        onChange={(e) => handleUserDetail(e, each.seatId)}
                      >
                        <option selected>Open this select menu</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                      {error && error[`userTicketDetails[${i}].gender`] && (
                        <p style={{ color: "red" }}>
                          {error[`userTicketDetails[${i}].gender`]}
                        </p>
                      )}
                    </div>
                    <div className="col-md-3 mt-3">
                      <h6>Group</h6>
                      <select
                        class="form-select"
                        value={each.group}
                        aria-label="Default select example"
                        name="agegroup"
                        onChange={(e) => handleUserDetail(e, each.seatId)}
                      >
                        <option selected>Open this select menu</option>
                        <option value="Adult">Adult</option>
                        <option value="Senior">Senior-Citizen</option>
                        <option value="Child">Child</option>
                      </select>
                      {error && error[`userTicketDetails[${i}].agegroup`] && (
                        <p style={{ color: "red" }}>
                          {error[`userTicketDetails[${i}].agegroup`]}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
            </div>
            <div className="col-md-6 mt-3">
              <h6>Payment Mode</h6>
              <div className="d-flex gap-5">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="payment"
                    value={"offline"}
                    onClick={(e) => setPaymentMode(e.target.value)}
                  />
                  <label class="form-check-label" for="radioDefault1">
                    Offline
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="payment"
                    value={"online"}
                    id="radioDefault2"
                    onClick={(e) => setPaymentMode(e.target.value)}
                  />
                  <label class="form-check-label" for="radioDefault2">
                    Online
                  </label>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h6>Receipt Details</h6>
              <input
                type="text"
                name="upiReceipt"
                value={userContactDetail.upiReceipt}
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                disabled={paymentMode === "offline"}
                onChange={handleUserContactDetail}
              />
              {error && error[`userTicketDetails[0].upiReceipt`] && (
                <p style={{ color: "red" }}>
                  {error[`userTicketDetails[0].upiReceipt`]}
                </p>
              )}
            </div>

            <div className="col-md-4">
              <button
                className="btn btn-primary"
                onClick={submitAdminBook}
                disabled={buttonLock}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TicketBookingForm;
